import StudentNotes from './StudentNotes';

export default StudentNotes;
